 <!-- cvue -->
<template>
    <div class="g-form" ref="gform">
        <div class="g-form-conteudo">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import gForm from './g-form.js'
    export default gForm
</script>

<style scoped>

.g-form{
    width: 100%;
}

.g-form-label{
    text-align: left;
    font-weight: bold;
    color:#707070;
}

::placeholder{
    color:#8A8A8A;
}
/* Drop down */
.g-input-dropDown{
    text-align: left;
    width:100%;
    margin-top:15px;
    margin-bottom:15px;
}
/* Checkbox */
.g-input-checkBox{
    /* display: inline-flex; */
    width: 100%;
    align-content: left;
    margin-top:15px;
    margin-bottom:15px;
    color:#8A8A8A
}

.g-input-checkBox-label{
    padding-left: 5px;
    color:#8A8A8A;
}
/* Labels */
/* InputText */

:deep(.global-input-search) {
    padding: 0.4rem 0.5rem;
}

:deep(.p-inputtext:enabled:hover){
    border-color:#D6D6D6;
}
:deep(.g-form-conteudo .g-input-label) {
    font-weight: bold;
    font-size: 14px;
    font-family: Montserrat;
    color:#4F4C4D;
    padding: 5px 0;
}

:deep(.p-dropdown:not(.p-disabled):hover){
    border-color:#8a8a8a;
}

:deep(.g-form-conteudo .p-inputtext:enabled:focus){
    outline: none;
    box-shadow: none;
    border-color:#8a8a8a;
}
:deep(.g-form-conteudo .p-dropdown:not(.p-disabled).p-focus){
    border-color: #8a8a8a;
    box-shadow: none;
}

:deep(.p-dropdown .p-dropdown-label.p-placeholder){
    color:#8A8A8A;
    display: flex;
}
:deep(.p-dropdown .p-dropdown-trigger){
    color:#8A8A8A;
}

/* :deep(.g-form-conteudo .p-checkbox .p-checkbox-box.p-highlight){
    border-color:#D6D6D6;
    background: #4f2c19;
} */

/* :deep(.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover){
    border-color:#D6D6D6;
    background: #4f2c19;
} */

:deep(.g-form-conteudo .p-checkbox.p-checkbox-box.p-focus ){
    box-shadow: transparent;
}
/* :deep(.g-form-conteudo .p-checkbox .p-highlight.p-checkbox-box.p-focus){
    border-color: #D6D6D6;
    box-shadow: none;
} */
/* :deep(.g-form-conteudo .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus){
    border-color: #D6D6D6;
    box-shadow: none;
} */
</style>